<script>
import Layout from "@/router/layouts/main";
import Breadcrumb from "@/components/Breadcrumb";
import ReferralLink from "@/components/ReferralLink";

export default {
  locales: {
    pt: {
      "Refer Broker": "Indicar Corretor",
      "Share your link to refer brokers to your network.": "Compartilhe seu link para indicar corretores para a sua rede.",
    },
    es: {
      "Refer Broker": "Indicar Corredor",
      "Share your link to refer brokers to your network.": "Comparta su link para indicar corredores a su red.",
    },
  },
  components: {
    Layout,
    Breadcrumb,
    ReferralLink,
  },
};
</script>

<template>
  <Layout>
    <Breadcrumb :items="[{ text: 'Indicados' }, { text: 'Indicar Corretor' }]" />
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-md-flex justify-content-between">
          <div>
            <h3 class="mb-0">{{ t("Refer Broker") }}</h3>
          </div>
        </div>
      </div>
    </div>
    <p>{{ t("Share your link to refer brokers to your network.") }}</p>
    <ReferralLink></ReferralLink>
  </Layout>
</template>
